import { schema } from 'normalizr';

export const artist = new schema.Entity('artists');

export const shopifyProduct = new schema.Entity('shopifyProducts');

export const collection = new schema.Entity('collections');

export const metadata = new schema.Entity('metadata', {
  featuredCollection: collection
});

export const product = new schema.Entity('products', {
  artist,
  collection,
  metadata,
  shopifyProduct
});

collection.define({
  products: new schema.Array(product)
});

product.define({
  shopifyProduct: shopifyProduct
});



// WEBPACK FOOTER //
// ./src/store/schema.js